import { gql } from "graphql-tag";

export const deleteUserMutation = gql`
mutation deleteUser($profileId: Int) {
    deleteUser(profileId: $profileId) {
      status
      errorMessage
    }
  }`;

export const getAllUsersQuery = gql`
query getAllUsers($currentPage: Int, $searchList: String, $userType: Int){
  getAllUsers(currentPage: $currentPage, searchList: $searchList, userType: $userType){
    count
    results {
      id
      encryptEmail
      phoneDialCode
      phoneCountryCode
      encryptPhoneNumber
      isBan
      userStatus
      createdAt
      profile {
        profileId
        encryptFirstName
        encryptLastName
        country
        walletBalance
        preferredCurrency
      }
    }
  }
}`;

export const updateUserMutation = gql`
    mutation updateUser(
        $id: ID,
        $firstName: String,
        $lastName: String,
        $email: String,
        $phoneDialCode: String
        $phoneNumber: String,
        $userStatus: String,
        $isBan: Int
        $phoneCountryCode: String
        $preferredCurrency: String
        ) {
          updateUser(
          id: $id
          firstName: $firstName
          lastName: $lastName
          email:$email
          phoneDialCode: $phoneDialCode
          phoneNumber: $phoneNumber
          userStatus: $userStatus
          isBan: $isBan
          phoneCountryCode: $phoneCountryCode
          preferredCurrency: $preferredCurrency
        )
        {
          status
          errorMessage
        }
      }`;

export const updatePartnerMutation = gql`
      mutation updatePartner(
          $id: ID,
          $firstName: String,
          $lastName: String,
          $email: String,
          $phoneDialCode: String
          $phoneNumber: String,
          $userStatus: String,
          $isBan: Int,
          $phoneCountryCode: String
          $preferredCurrency: String
          ) {
            updatePartner(
            id: $id
            firstName: $firstName
            lastName: $lastName
            email:$email
            phoneDialCode: $phoneDialCode
            phoneNumber: $phoneNumber
            userStatus: $userStatus
            isBan: $isBan
            phoneCountryCode: $phoneCountryCode
            preferredCurrency: $preferredCurrency
          )
          {
            status
            errorMessage
          }
        }`;

export const uploadProfileImageMutation = gql`
        mutation uploadProfileImage($userId:ID,$picture:String){
            uploadProfileImage(userId:$userId, picture:$picture) {
              status
            }
          }`;

export const userAccount = gql`
          query userAccount{
            userAccount{
            result {
                  userId
                  profileId
                  firstName
                  lastName
                  email
                  picture
                  userStatus
                  userType
                  phoneNumber
                  phoneDialCode
                  phoneCountryCode
                  flagImage
                  preferredLanguage
                  preferredCurrency
                  preferredLocation
                  country
                  city
                  state
                  zipcode
                  address
                  lat
                  lng
                  key
              }
             status
             errorMessage
            }
          }
          `

export const createUser = `
    mutation createUser(
    		$firstName: String,
    		$lastName: String,
    		$email: String!,
    		$phoneDialCode: String!,
    		$phoneNumber: String!,
    		$phoneCountryCode: String!,
    		$lat: Float,
    		$lng: Float,
    		$city: String,
    		$state:String,
    		$zipcode: String,
    		$country: String,
    		$userType: Int!,
    		$preferredLanguage: String,
        $address: String,
        $preferredLat: Float,
    		$preferredLng: Float,
        $preferredLocation: String
        $deviceId: String
    ) {
    		createUser (
    				firstName: $firstName,
    				lastName: $lastName,
    				email: $email,
    				phoneDialCode: $phoneDialCode,
    				phoneNumber: $phoneNumber,
    				phoneCountryCode: $phoneCountryCode,
    				lat: $lat,
    				lng: $lng,
    				city: $city,
    				state: $state,
    				zipcode: $zipcode,
    				country: $country,
    				userType: $userType,
    				preferredLanguage: $preferredLanguage
            address: $address
            preferredLat: $preferredLat
            preferredLng: $preferredLng
            preferredLocation: $preferredLocation
            deviceId: $deviceId
    		) {
    				result {
    						userId
    						userToken
                token
                expiresIn
    				}
    				status
    				errorMessage
    		}
    }
    `

export const userLogout = gql`mutation userLogout($userType: Int) {
      userLogout (
          userType: $userType
      ) {
          status
          errorMessage
      }
    }`

export const updatePaymentMethod = `
    mutation updatePaymentMethod($paymentMethodId: Int!) {
      updatePaymentMethod(paymentMethodId: $paymentMethodId) {
        status
        errorMessage
      }
    }
  `;

export const addCardDetails = gql`mutation addCardDetails($paymentMethod: String!, $cardLastFour: String!) {
    addCardDetails(paymentMethod: $paymentMethod, cardLastFour: $cardLastFour) {
         status
         errorMessage
         result{
            requireAdditionalAction
            paymentIntentSecret
            paymentIntentId
         }
    }
  }`;

export const getPaymentMethod = gql`
  query {
   	getPaymentMethod {
		result {
			preferredPaymentMethod
      paymentMethodId
      cardLastFour
      walletBalance
		}
		status
		errorMessage
	}
  }
`;

export const confirmSetupIntent = gql`mutation confirmSetupIntent($setupIntentId: String!, $cardLastFour: String!, $paymentMethod: String!) {
	confirmSetupIntent(setupIntentId: $setupIntentId, cardLastFour: $cardLastFour, paymentMethod: $paymentMethod) {
		status
		errorMessage
     result{
          requireAdditionalAction
          paymentIntentSecret
       }
	}
}`

export const removeCardDetails = gql`mutation removeCardDetails {
	removeCardDetails {
		status
		errorMessage
	}
}`;

export const updateUserProfile = `mutation updateUserProfile($firstName: String!, $lastName: String!, $preferredCurrency: String!) {
  updateUserProfile(firstName: $firstName, lastName: $lastName, preferredCurrency: $preferredCurrency) {
      status
      errorMessage
  }
}`
export const getUserCategoryQuery = gql`
         query getUserCategory($profileId: Int!) {
            getUserCategory(profileId: $profileId) {
              id
              mainCategoryId
              subCategoryId
              basePrice
              currency
              category {
                 logoImage
                 name
              }
            }
          }`;

export const userCategoryMutation = gql`
          mutation userCategory($data:String,$categoryId:Int,$profileId:Int){
          userCategory(data:$data,categoryId:$categoryId,profileId:$profileId){
            status
            errorMessage
          }
        }`

export const writeReviews = gql`mutation writeReviews(
    $userId: String
    $bookingId: Int
    $authorId: String
    $ratings: Float 
  ) {
writeReviews (
    userId: $userId
    bookingId: $bookingId
    authorId: $authorId
    ratings: $ratings
) {
    status
    errorMessage
}
}`

export const updateReviewStatus = gql`mutation updateReviewStatus(
  $bookingId: Int
  $isReviewPageVisited: Boolean
) {
updateReviewStatus (
  bookingId: $bookingId
  isReviewPageVisited: $isReviewPageVisited
) {
  status
  errorMessage
}
}`